import { Autocomplete, Grid, TextField } from "@mui/material";
import * as labels from "config.labels";
import { useSelector } from "react-redux";
import * as staticDataHooks from "store/hooks/staticDataHooks";
import * as userSelectors from "store/selectors/user/userSelectors";

const AuditFrequency = ({ layer, updateLayer }) => {
  const translateLabel = staticDataHooks.useTranslator("uiLabels");
  const componentVisibility =
    useSelector(userSelectors.selectUserConfig)?.componentVisibility ?? {};
  const auditableCheckboxVisible =
    componentVisibility["<ActiveLayerEditor>.auditable"] ?? false;

  // When the Auditable checkbox is also configured, it acts as the gate:
  // the selector only appears for layers marked auditable.
  if (auditableCheckboxVisible && layer?.auditable !== true) {
    return null;
  }

  const auditFrequencies = [
    {
      key: "ANNUALLY",
      label: translateLabel(
        labels.ACTIVE_LAYER_PANEL_AUDIT_FREQUENCY_ANNUALLY,
        {
          default: "Annually",
        }
      ),
    },
    {
      key: "SEMI_ANNUALLY",
      label: translateLabel(
        labels.ACTIVE_LAYER_PANEL_AUDIT_FREQUENCY_SEMI_ANNUALLY,
        {
          default: "Semi-Annually",
        }
      ),
    },
    {
      key: "QUARTERLY",
      label: translateLabel(
        labels.ACTIVE_LAYER_PANEL_AUDIT_FREQUENCY_QUARTERLY,
        {
          default: "Quarterly",
        }
      ),
    },
    {
      key: "MONTHLY",
      label: translateLabel(labels.ACTIVE_LAYER_PANEL_AUDIT_FREQUENCY_MONTHLY, {
        default: "Monthly",
      }),
    },
  ];

  return (
    <Grid item xs={6}>
      <Autocomplete
        value={
          auditFrequencies.find(({ key }) => key === layer?.auditFrequency) ??
          null
        }
        onChange={(_, value) =>
          updateLayer({
            auditFrequency: value?.key ?? null,
          })
        }
        options={auditFrequencies}
        renderInput={(params) => (
          <TextField
            {...params}
            variant={"filled"}
            label={translateLabel(
              labels.ACTIVE_LAYER_PANEL_AUDIT_FREQUENCY_LABEL,
              {
                default: "Audit Frequency",
              }
            )}
            InputLabelProps={{ shrink: true }}
          />
        )}
        autoHighlight
        sx={{ width: "100%" }}
        disabled={layer?.loadingPurePremium}
        id={"layer-pricing-audit-frequency"}
      />
    </Grid>
  );
};

export default AuditFrequency;
